import { tagPurchase } from "../../../../utils/sendTag";
import useBotControlStore from "../../../../storeModules/useBotControlStore";
import findStep from "../findStep";
import { getPaymentBoleto } from "../../../../api/requests";
import useUserStore from "../../../../storeModules/useUserStore";
import useConsorcioStore from "../../../../storeModules/useConsorcioStore";
import useInitialConfigStore from "../../../../storeModules/useInitialConfigStore";
import { metodosPagamentoNames } from "../../../../utils/constants";
import noConnectionHandler from "../../../../utils/noConnectionHandler";
import { sanitizeUrl } from "../../../../utils/sanitize";

const handleGetPaymentBoleto = async () => {
  await noConnectionHandler().then(() => {
    getPaymentBoleto();
  });
};

const pagamentoBoletoSteps = [
  {
    name: "gerando_boleto",
    sender: "bot",
    text: "Certo! Estou <b>registrando</b> o seu boleto",
    action: async () => {
      handleGetPaymentBoleto();
    },
  },
  {
    name: "parabens_boleto",
    sender: "bot",
    isWaitingForFetch: true,
    text: () => {
      const basicUserName = useUserStore.getState().basic.nome;
      return `Pronto, ${basicUserName}! Parabéns por dar esse passo rumo a sua conquista!`;
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("opcoes_boleto").index,
      });
    },
  },
  {
    name: "opcoes_boleto",
    sender: "bot",
    text: "Selecione uma das opções abaixo para <b>realizar o pagamento:</b>",
    options: [
      {
        text: "COPIAR CÓDIGO",
        action: async () => {
          tagPurchase(metodosPagamentoNames.BOLETO);

          useBotControlStore.setState({
            currentStep: findStep("codigo_boleto").index,
          });
        },
      },
      {
        text: "ABRIR BOLETO",
        action: async () => {
          const boletoUrl = useUserStore.getState().payment.boleto.boletoURL;
          tagPurchase(metodosPagamentoNames.BOLETO);

          if (boletoUrl) {
            window.open(sanitizeUrl(boletoUrl), "_blank");

            useBotControlStore.setState({
              currentStep: findStep("abrir_app_banco").index,
            });
          }
        },
      },
      {
        text: "ALTERAR FORMA DE PAGAMENTO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("alterar_forma_pagamento").index,
          });
        },
      },
    ],
  },
  {
    name: "codigo_boleto",
    sender: "bot",
    text: "Este é o <b>código</b> de barras do <b>boleto</b>:",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("exibe_codigo_boleto").index,
      });
    },
  },
  {
    name: "exibe_codigo_boleto",
    sender: "bot",
    text: () => {
      return useUserStore.getState().payment.boleto.boletoCodigoBarras;
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("copiar_codigo_boleto").index,
      });
    },
  },
  {
    name: "copiar_codigo_boleto",
    sender: "bot",
    text: "<b>Clique</b> no botão para <b>copiar o código</b> do boleto para <b>pagar</b> a sua primeira parcela.",
    options: [
      {
        text: "COPIAR CÓDIGO",
        action: () => {
          navigator.clipboard.writeText(
            useUserStore.getState().payment.boleto.boletoCodigoBarras
          );

          useBotControlStore.setState({
            currentStep: findStep("abrir_app_banco").index,
          });
        },
      },
    ],
  },
  {
    name: "abrir_app_banco",
    sender: "bot",
    text: "Agora entre no <b>APP do seu banco</b> e faça o <b>pagamento</b> o quanto antes ;)",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("proxima_assembleia").index,
      });
    },
  },
  {
    name: "proxima_assembleia",
    sender: "bot",
    text: "Assim você já participa da <b>próxima assembleia</b> e quem sabe, já pode ser um dos <b>contemplados</b>.",
    options: [
      {
        text: "CONTINUAR",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("compra_finalizada").index,
          });
        },
      },
    ],
  },
  {
    name: "erro_boleto_tentar_novamente",
    sender: "bot",
    text: `<b>OPS! </b>Tivemos um problema para gerar o BOLETO! O quê você deseja fazer?`,
    isWaitingForFetch: true,
    options: () => {
      return useConsorcioStore
        .getState()
        .fetchedProposta.formasPagamentoDisponiveis.filter((code) =>
          [5, 0, 1].includes(code)
        )
        .map((code) => {
          const options = {
            5: {
              text: "PAGAR COM PIX",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("registro_pix").index,
                });
              },
            },
            0: {
              text: "PAGAR COM CARTÃO",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("mensagem_seguranca_cartao")
                    .index,
                });
              },
            },
            1: {
              text: "TENTAR NOVAMENTE",
              action: () => {
                useBotControlStore.setState({
                  currentStep: findStep("gerando_boleto").index,
                });
              },
            },
          };
          return options[code];
        })
        .concat([
          {
            text: "FALAR COM NOSSOS ESPECIALISTAS",
            action: () => {
              const linkWhatsApp =
                useInitialConfigStore.getState().linkWhatsApp;
              window.open(sanitizeUrl(linkWhatsApp), "_blank");
            },
          },
        ]);
    },
  },
];

export default pagamentoBoletoSteps;
